import { Box } from '@chakra-ui/react';
import PalommaLogoWithText from './svg/PalommaLogoWithText';
import PCIDisclaimer from './svg/PCIDisclaimer';
import { useBreakpointsContext } from '../hooks/useBreakpointsContext';

const Footer = () => {
  const { isSmallScreen } = useBreakpointsContext();

  return (
    <Box
      display="flex"
      flexDirection="row"
      height="60px"
      width="100%"
      justifyContent={isSmallScreen ? 'center' : 'flex-end'}
      alignItems="center"
      gap="20px"
    >
      <PCIDisclaimer />
      <PalommaLogoWithText />
    </Box>
  );
};

export default Footer;
